import { useEffect } from 'react';
import Title from '../../components/Title';
import capacity from '../../assets/img/Capacity.png';
import revenue from '../../assets/img/Revenue.png';
import errors from '../../assets/img/Errors.png';
import followers from '../../assets/img/Followers.png';
import chart1 from '../../assets/img/chart1.png';
import chart2 from '../../assets/img/chart2.png';
import chart3 from '../../assets/img/chart3.png';
import { Helmet } from 'react-helmet';
import { useDispatch } from 'react-redux';

export default function DashboardPage() {
    const dispatch = useDispatch();
    useEffect(() => {}, [dispatch]);

    return (
        <div>
            <Helmet>
                <title>Console Defentry - Dashboard</title>
            </Helmet>
            <Title>Your Dashboard</Title>
            <div className="metrics__wrapper">
                <img
                    className="metrics__thumb"
                    src={capacity}
                    alt="Capacity"
                    width={257}
                    height={136}
                />
                <img
                    className="metrics__thumb"
                    src={revenue}
                    alt="Revenue"
                    width={257}
                    height={136}
                />
                <img
                    className="metrics__thumb"
                    src={errors}
                    alt="Errors"
                    width={257}
                    height={136}
                />
                <img
                    className="metrics__thumb"
                    src={followers}
                    alt="Followers"
                    width={257}
                    height={136}
                />
            </div>
            <div>
                <img
                    src={chart1}
                    alt="Chart1"
                    style={{ marginBottom: '24px' }}
                />
                <div style={{ display: 'flex' }}>
                    <img
                        src={chart2}
                        alt="Chart2"
                        style={{ marginRight: '24px' }}
                    />
                    <img src={chart3} alt="Chart3" />
                </div>
            </div>
        </div>
    );
}
